import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { configs } from '../../configs';
import styles from '../../styles/styles-desktop.css';

import type { TButton, IButtonDeps } from './models';
import { ButtonIncreaseComponent } from './button-increase';

// Компоненту не требуется функционал стайлера
// eslint-disable-next-line styler/check-styler
export const ButtonIncreaseDesktop = createWidget<IButtonDeps, TButton>({
    configs,
    styles,
})(ButtonIncreaseComponent);
